import { render } from "./App.vue?vue&type=template&id=04c16fab"
const script = {}

import "./index.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/codebuild/output/src903112286/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__